import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class AutoplayCheckAfterFeatureUIAct extends SyncUIActDecorator {
    public execute(): void {
        const {autoplayOptionsBeforeFeature, feature_autoplayUntilBonusEnabled, logic_nextActionIsSpin} = slotStore.values();

        if (!feature_autoplayUntilBonusEnabled && autoplayOptionsBeforeFeature?.autoplaySpins && logic_nextActionIsSpin) {
            slotStore.batchUpdate({
                autoplayOptions: autoplayOptionsBeforeFeature,
                autoplayOptionsBeforeFeature: null,
                isAutoplay: true
            });
        }
        this.onExecuted?.();
    }

    getName(): string {
        return 'AutoplayCheckAfterFeatureUIAct';
    }
}